import React from 'react';

const {
    hooks: {useHover, useSelector},
    css: {prefixCSS}
} = polyphony;

const styles = {
    cloud: prefixCSS({

    }),
    term: {
        margin: 10,
        padding: 10,
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'inline-block'
    }
};

const urlForTerm = (term, taxonomy) => {
    const url = new URL(window.location.href);
    url.searchParams.set('include_terms_from', taxonomy);
    if (term) {
        url.searchParams.set('taxonomy', term.taxonomy.name);
        url.searchParams.set('term', term.slug);
    } else {
        url.searchParams.delete('taxonomy');
        url.searchParams.delete('term');
    }

    return url.toString();
};

const TermCloudTerm = ({term}) => {
    const [{hover}, ref] = useHover();

    const {slug, name} = term || {slug: 'all', name: 'All'};

    const pressed = useSelector(s => {
        const tq = s.query.tax_query;
        return tq ? tq.some(({field, terms}) => field === 'slug' && terms.includes(slug)) : slug === 'all';
    });
    const includedTaxonomy = useSelector(s => s.query.include_terms_from);

    return <a key={slug}
              ref={ref}
              href={urlForTerm(term, includedTaxonomy)}
              data-behavior='replace'
              style={{...styles.term, color: hover || pressed ? 'gray' : 'inherit'}}
              role='button'
              aria-pressed={pressed}
              aria-label={name}>
        {name}
    </a>;
};

const TermCloud = () => {
    const terms = useSelector(({included_terms: ic}) => {
        return ic ? ic.filter(({slug}) => slug !== 'uncategorized') : ic;
    });
    return (
        <nav aria-label="Filtering Controls" className='term-cloud' style={styles.cloud}>
            {terms.length > 0 && <TermCloudTerm key='all'/>}
            {terms.map((t, idx) => <TermCloudTerm term={t} key={`${t.slug} ${idx}`} />)}
        </nav>
    );
};

export default TermCloud;

